import React from 'react';
import {Box} from '@mui/material';
import './ProjectFieldList.scss';
import {ProjectFieldGrid} from './components/ProjectFieldGrid';
import ManageHeader from '../components/manage-header/ManageHeader';
import {t} from 'i18next';

const ProjectFieldList: React.FC = () => {
  return (
    <Box className="project-field-list-container">
      <ManageHeader
        title={t('manageProjectFields.title')}
        infoContentTitle={t('manageProjectFields.headerTooltip.title')}
        infoContent={'manageProjectFields.headerTooltip.content'}
        isShowGroup={false}
      />
      <ProjectFieldGrid selectedGroup={null} />
    </Box>
  );
};

export default ProjectFieldList;
